import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=cab279a8&scoped=true&"
import script from "./snackbar.vue?vue&type=script&lang=js&"
export * from "./snackbar.vue?vue&type=script&lang=js&"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=cab279a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab279a8",
  null
  
)

export default component.exports